
import { AppRole } from '@/types/auth';
import { roleValidationService } from './security/roleValidationService';
import { securityLogger } from './security/securityLogger';
import { validationUtils } from './security/validationUtils';
import { policyService } from './security/policyService';
import { enhancedSecurityService } from './security/enhancedSecurityService';
import { inputValidationService } from './security/inputValidationService';

export const securityService = {
  // Role validation methods
  validateUserRole: roleValidationService.validateUserRole,
  validateUserHasAnyRole: roleValidationService.validateUserHasAnyRole,
  getUserRolePriority: roleValidationService.getUserRolePriority,

  // Security logging
  logSecurityEvent: securityLogger.logSecurityEvent,

  // Policy management
  checkPolicyConflicts: policyService.checkPolicyConflicts,

  // Validation utilities
  sanitizeInput: validationUtils.sanitizeInput,
  checkRateLimit: validationUtils.checkRateLimit,

  // Enhanced security features
  checkRateLimitEnhanced: enhancedSecurityService.checkRateLimit,
  sanitizeAndValidateInput: enhancedSecurityService.sanitizeAndValidateInput,
  validateOrganizationAccess: enhancedSecurityService.validateOrganizationAccess,
  logEnhancedSecurityEvent: enhancedSecurityService.logSecurityEvent,
  validateAdminOperation: enhancedSecurityService.validateAdminOperation,

  // Input validation
  validateTextInput: inputValidationService.validateTextInput,
  validateEmail: inputValidationService.validateEmail,
  validateNumericInput: inputValidationService.validateNumericInput,
  validateOrganizationName: inputValidationService.validateOrganizationName,
  validateFileUpload: inputValidationService.validateFileUpload,
  validateUrl: inputValidationService.validateUrl
};
